import smoothscroll from 'smoothscroll-polyfill';
import './js/homepageSlider';
import './js/projectSlider';
import './js/blog';
import {GlobalProvider} from "./contexts/Provider";
import ContactForm from "./components/ContactForm";
import React from "react";
import ReactDOM from "react-dom";
import CareerForm from "./components/CareerForm";

smoothscroll.polyfill();
document.addEventListener("DOMContentLoaded", () => {
    let doc = document;
    let body = doc.querySelector('body');
    let html = doc.querySelector('html');
    let header = doc.querySelector('header');
    const hamburger = doc.querySelector('.hamburger');

    hamburger.addEventListener('click', function () {
        body.classList.toggle('open-menu');
    });

    const careerList = doc.querySelector('.career-list');
    if (careerList) {
        let items = careerList.querySelectorAll('.career-item');
        items.forEach((item) => {
            item.querySelector('.career-item__title').addEventListener('click', () => {
                item.classList.toggle('open');
            })
            const button = item.querySelector('button');
            button.addEventListener('click', () => {
                let id = button.getAttribute('data-career-id');
                const careerFormElement = doc.getElementById('career-form');
                body.classList.add('open-career-form');
                ReactDOM.render(
                    <GlobalProvider careerId={id}>
                        <CareerForm />
                    </GlobalProvider>
                    , careerFormElement
                )
            })
        })
    }

    const contactFormElement = doc.getElementById('contact-form');
    if (contactFormElement) {
        ReactDOM.render(
            <GlobalProvider>
                <ContactForm />
            </GlobalProvider>
            , contactFormElement
        )
    }

    const departments = doc.querySelectorAll('.department');
    if (departments.length > 0) {
        departments.forEach((department) => {
            department.querySelector('.department__content > button').addEventListener('click', () => {
                department.classList.toggle('open');
            })
        })
    }

    const anchors = doc.querySelectorAll('.slideTo');
    if (anchors) {
        anchors.forEach(function (anchor) {
            anchor.addEventListener('click', (e) => {
                e.preventDefault();
                let element = doc.querySelector(anchor.getAttribute('href'));
                let header = doc.querySelector('header');
                window.scroll({
                    top: element.getBoundingClientRect().top + window.scrollY - header.clientHeight,
                    behavior: 'smooth'
                });
            })
        });
    }

    if (window.location.hash) {
        let hash = window.location.hash;
        let element = doc.querySelector(hash);
        if (hash.length > 0 && element) {
            window.scroll({
                top: 0
            });
            let header = doc.querySelector('header');
            window.scroll({
                top: element.getBoundingClientRect().top + window.scrollY - header.clientHeight,
                behavior: 'smooth'
            });
        }
    }

    let btnShare = document.querySelectorAll('.btn-share');
    if (btnShare) {
        [].forEach.call(btnShare, function (btn) {
            btn.addEventListener('click', (e) => {
                let width = 575,
                    height = 400,
                    left = (window.innerWidth - width) / 2,
                    top = (window.innerHeight - height) / 2,
                    url = e.currentTarget.href,
                    opts = 'status=1' +
                        ',width=' + width +
                        ',height=' + height +
                        ',top=' + top +
                        ',left=' + left;
                window.open(url, 'twitter', opts);
                e.preventDefault();
            })
        });
    }

    window.addEventListener("scroll", function (e) {
        let scroll = this.scrollY || document.documentElement.scrollTop;
        if (scroll > 0) {
            body.classList.add('scroll');
        } else {
            body.classList.remove('scroll');
        }
    });


});
